import { CheckSquare, Square, ChevronDown } from 'lucide-react';
import { cn } from '@/utils/cn';

interface SummaryContentSectionProps {
  formData: any;
  setFormData: (data: any) => void;
}

export function SummaryContentSection({ formData, setFormData }: SummaryContentSectionProps) {
  return (
    <section className="space-y-6">
      <h2 className="sm:text-sm text-xs font-semibold text-emerald-900 tracking-wide uppercase">Nội dung tóm tắt</h2>
      
      <div className="space-y-5">
        <div className="space-y-2">
          <label className="sm:text-sm text-xs text-slate-700">Mô tả ngắn <span className="text-rose-500">*</span></label>
          <div className="relative">
            <textarea 
              rows={3}
              placeholder="Nhập mô tả ngắn gọn về vấn đề hoặc nhu cầu đề xuất..."
              value={formData.description}
              onChange={e => setFormData((prev: any) => ({ ...prev, description: e.target.value }))}
              className="w-full rounded-md border border-slate-200 bg-white p-3 pb-8 sm:text-sm text-xs text-slate-900 focus:border-emerald-500 focus:outline-none transition-all resize-none placeholder:text-slate-400"
            />
            <span className="absolute bottom-3 right-3 sm:text-sm text-xs text-slate-400">{formData.description.length}/500</span>
          </div>
        </div>

        <div className="space-y-3">
          <label className="sm:text-sm text-xs text-slate-700">Phạm vi ảnh hưởng</label>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              { id: 'toan_bo', label: 'Toàn bộ khu vực' },
              { id: 'mot_phan', label: 'Một phần khu vực' },
              { id: 'hang_muc', label: 'Một hạng mục' },
              { id: 'vi_tri', label: 'Một vị trí cụ thể' }
            ].map(item => (
              <label 
                key={item.id}
                className="flex items-center gap-2 cursor-pointer group" 
                onClick={() => setFormData((prev: any) => ({ ...prev, impactScope: item.id }))}
              >
                {formData.impactScope === item.id ? (
                  <CheckSquare className="h-5 w-5 text-emerald-600" />
                ) : (
                  <Square className="h-5 w-5 text-slate-300" />
                )}
                <span className={cn("sm:text-sm text-xs", formData.impactScope === item.id ? "text-slate-800" : "text-slate-500")}>{item.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="space-y-2 md:w-1/2">
          <label className="sm:text-sm text-xs text-slate-700">Vị trí / Hạng mục liên quan</label>
          <div className="relative">
            <select 
              value={formData.relatedAssetId}
              onChange={e => setFormData((prev: any) => ({ ...prev, relatedAssetId: e.target.value }))}
              className="h-11 w-full appearance-none rounded-md border border-slate-200 bg-white px-3 pr-10 sm:text-sm text-xs text-slate-400 focus:border-emerald-500 focus:outline-none transition-all"
            >
              <option value="">Chọn vị trí hoặc hạng mục liên quan</option>
            </select>
            <ChevronDown className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400 pointer-events-none" />
          </div>
        </div>

        <div className="space-y-2">
          <label className="sm:text-sm text-xs text-slate-700">Lý do đề xuất <span className="text-rose-500">*</span></label>
          <div className="relative">
            <textarea 
              rows={4}
              placeholder="Trình bày lý do cần đề xuất, thực trạng hiện tại, vấn đề phát sinh..."
              value={formData.reason}
              onChange={e => setFormData((prev: any) => ({ ...prev, reason: e.target.value }))}
              className="w-full rounded-md border border-slate-200 bg-white p-3 pb-8 sm:text-sm text-xs text-slate-900 focus:border-emerald-500 focus:outline-none transition-all resize-none placeholder:text-slate-400"
            />
            <span className="absolute bottom-3 right-3 sm:text-sm text-xs text-slate-400">{formData.reason.length}/1000</span>
          </div>
        </div>
      </div>
    </section>
  );
}
